<template>
  <bita-modal
      :id="modalId"
      :title="title"
      :modal-sm="true"
      :isLoading="isLoading"
      @close="onCloseModal"
  >
    <div slot="body">
      <bita-form ref="form">
        <div slot="body">
          <div class="row">
            <bita-select
                name="state_id"
                label="وضعیت"
                rules="required"
                validation-container-class="col-12"
                input-class="form-control"
                :data-source="states"
                data-text-field="title"
                data-value-field="value"
                v-model="dataForm.state_id"
            />
          </div>
        </div>
      </bita-form>
    </div>
    <div slot="footer">
      <bita-bootbutton
          v-if="!propsData.id"
          type="primary"
          title="ذخیره"
          icon="fa fa-check"
          btn-width="150px"
          @click.native="handleSubmit()"
      />
      <bita-bootbutton
          v-if="propsData.id"
          type="primary"
          title="بروزرسانی"
          icon="fa fa-check"
          btn-width="150px"
          @click.native="handleSubmit()"
      />
    </div>
  </bita-modal>
</template>
<script>
export default {
  props: {
    modalId: {},
    isLoading: {},
    title: {},
    onSubmit: {},
    propsData: {
      type: Object,
      default: {
        state_id: 0,
      },
    },
  },
  data() {
    return {
      colWidth: "col-lg-12",
      dataForm: {},
      states: [
        {
          title: "غیر فعال",
          value: 0,
        },
        {
          title: "فعال",
          value: 1,
        },
        {
          title: "بلاک شده",
          value: 2,
        },
        {
          title: "ویرایش راننده",
          value: 3,
        },
        {
          title: "ایمپورت شده",
          value: 4,
        },
        {
          title: "بلاک شده توسط ادمین",
          value: 5,
        },
        {
          title: "غیرفعال کردن ناوگان",
          value: 6,
        },
      ],
    };
  },
  watch: {
    propsData: function(_data) {
      this.dataForm = _data;
    },
  },
  methods: {
    handleSubmit() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.$emit("on-submit", this.dataForm);
        }
      });
    },
    reset() {
      let dropDowns = ["driversDropDown", "customerDropDown"];
      for (let ref of dropDowns) {
        if (this.$refs[ref]) this.$refs[ref].emptyKendo();
      }
      this.$refs.form.reset();
    },
    onCloseModal(e) {
      this.reset();
    },
  },
};
</script>
